import React from "react";
import "./App.css";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "jotai";
import RootRouter from "./routes";
import { ToastContainer } from "react-toastify";
import { CourtBookingProvider } from "./context/courtBookingContext";
import { StoreProvider } from "./stores/StoreContext";
import { UltraPromo } from "./screens/ultraPromo/UltraPromo";
import { DataDogProvider } from "./context/DataDogContext";

function App() {
  return (
    <StoreProvider>
      <Provider>
        <DataDogProvider>
          <Router>
            <Routes>
              {/* UltraPromo should not mount StoreProvider or CourtBookingProvider */}
              <Route path="/share-match/:id" element={<UltraPromo />} />

              {/* All other routes wrapped in providers */}
              <Route
                path="/*"
                element={
                  <CourtBookingProvider>
                    <RootRouter />
                    <ToastContainer />
                  </CourtBookingProvider>
                }
              />
            </Routes>
          </Router>
        </DataDogProvider>
      </Provider>
    </StoreProvider>
  );
}

export default App;
